import * as React from 'react'
import {connect} from 'react-redux'

import {REPLACEMENTS} from '../../../urls'
import {useParamsInteger, useEventData, useUserData} from '../../../pages/OrderManager/hooks'
import * as replacementsActions from '../../../actions/replacements'
import * as utils from './utils'
import {useEventListData} from './useEventList'
import {EventOrder} from '../types/eventData'

interface ReplacementLinkProps {
  startReplacements: ({eventId, orderId}: {eventId: number; orderId: number}) => void
  eventOrder: EventOrder
}

/*
  - useOrderData doesn't have isCancelled and isShipped data,
      So the order has to be derived from useEventData.orders
  - But useEventData doesn't have status, so we need to fetch
      from useEventListData and find it in the list
  - Doing all this in the Button component itself so it doesn't hold up the page render.
*/

const ReplacementsLink: React.FC<ReplacementLinkProps> = ({startReplacements, eventOrder}) => {
  const {eventId, orderId} = useParamsInteger(['eventId', 'orderId'])
  const {data: user} = useUserData()
  const {data: eventListData} = useEventListData(user?.id)
  const event = eventListData?.find((e: any) => e.id === eventId)

  const canRequestReplacements = utils.canRequestReplacements(user?.id, event, eventOrder)

  const handleReplacementsClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()

    startReplacements({eventId, orderId})
  }

  return canRequestReplacements ? (
    <li>
      <a
        data-testid="order-manager-order-items-request-replacements"
        href={REPLACEMENTS}
        onClick={handleReplacementsClick}
      >
        Request Replacement
      </a>
    </li>
  ) : null
}

const mapDispatchToProps = {
  startReplacements: replacementsActions.startReplacements,
}

export default connect(null, mapDispatchToProps)(ReplacementsLink)
